import { render, staticRenderFns } from "./PlatformConsole.vue?vue&type=template&id=0d0b4c9c&scoped=true"
import script from "./PlatformConsole.vue?vue&type=script&lang=js"
export * from "./PlatformConsole.vue?vue&type=script&lang=js"
import style0 from "./PlatformConsole.vue?vue&type=style&index=0&id=0d0b4c9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0b4c9c",
  null
  
)

export default component.exports